import {store} from "@/modules/core/stores/main-store";

async function initData(): Promise<void> {
    store.dispatch('gemeenten/fetchGemeenten');
}

export default initData